module.exports = __webpack_public_path__ + "assets/redis.bfe086f4.svg";